import { AreaConfig } from "@/3d/area/AreaConfig";
import { Space } from "@/3d/area/AreaLayout";
import { THEME_COLORS } from "@/utils/colors";
import { Color } from "three";

export const WALL_PROP_COLORS = [
    THEME_COLORS.generalBlack,
    THEME_COLORS.highlightedItemOrange,
    THEME_COLORS.highlightedItemPurple,
];

export type WallConfig = {
    key: string;
    thickness: number;
    color: Color;
    baseboardColor: Color;
    props: WallPropConfig[];
};

export type WallWindowConfig = {
    type: "window";
    key: string;
    width: number;
    height: number;
    floorOffset: number;
    offset: number;
    highlightColor: Color;
};

export type WallDoorConfig = {
    type: "door";
    key: string;
    width: number;
    height: number;
    offset: number;
    highlightColor: Color;
};

export type WallPropConfig = WallWindowConfig | WallDoorConfig;

export const WALL_PROP_SPACING = 0.1;
export const WALL_PROP_MIN_WIDTH = 0.1;
export const WALL_PROP_MIN_HEIGHT = 0.4;

export const getWallPropSpace = (prop: WallPropConfig): Space => {
    return {
        type: "1axis",
        start: prop.offset,
        end: prop.offset + prop.width,
        size: prop.width,
    };
};

export const getWallPropAreaConfig = (width: number): AreaConfig => {
    return {
        type: "1axis",
        minSize: width,
        maxSize: width,
        minParentStartOffset: WALL_PROP_SPACING,
        minStartOffset: WALL_PROP_SPACING,
        minEndOffset: WALL_PROP_SPACING,
    };
};

export const applyWallPropSpace = (
    space: Space,
    prop: WallPropConfig
): WallPropConfig | undefined => {
    if (space.size < prop.width) {
        return undefined;
    }

    return {
        ...prop,
        offset: space.start,
    };
};
